<template>
    <div id="contact-form">
        <h2 class="mt-0">{{ translate('contact.form.title') }}</h2>
        <p>{{ translate('contact.form.description') }}</p>
        <ServiceNotification :notifications="notifications" />

        <UIForm v-if="show" ref="contactForm" class="mt-4" novalidate>
            <label for="name" class="font-weight-bold mb-1">{{ placeholderName }}</label>
            <span class="required ml-1">({{ translate('required') }})</span>
            <UIFormInput
                id="name"
                v-model="form.name"
                name="name"
                type="text"
                required
                class="mb-3"
                autocorrect="off"
                validation="required"
            >
                <template #error-message>
                    {{ translate('name.error') }}
                </template>
            </UIFormInput>

            <label for="email" class="font-weight-bold mb-1">{{ placeholderEmail }}</label>
            <span class="required ml-1">({{ translate('required') }})</span>
            <UIFormInput
                id="email"
                v-model="form.email"
                name="email"
                type="email"
                required
                class="mb-3"
                autocorrect="off"
                validation="email"
            >
                <template #error-message>
                    {{ translate('email.error') }}
                </template>
                <template #warning-message>
                    {{ translate('email.warning') }}
                </template>
            </UIFormInput>

            <label for="message" class="font-weight-bold mb-1">{{ placeholderMessage }}</label>
            <span class="required ml-1">({{ translate('required') }})</span>
            <UIFormTextarea
                id="message"
                v-model="form.message"
                name="message"
                required
                :rows="3"
                :max-rows="6"
                class="mb-3"
                validation="required"
            >
                <template #error-message>
                    {{ translate('message.error') }}
                </template>
            </UIFormTextarea>

            <ServiceAttachment
                :files.sync="form.files"
                :top-level-errors="errors"
                :max-files="3"
                class="mb-3"
            ></ServiceAttachment>

            <UIButton type="submit" variant="primary" class="w-100" @click.prevent="onSubmit">{{
                translate('button.submit')
            }}</UIButton>
        </UIForm>
        <div v-if="!show" class="succes-box">
            <b>{{ translate('contactFormThanks') }} {{ form.name }}!</b><br />
            {{ translate('contactFormResponseTime') }}
        </div>
    </div>
</template>

<script>
import { UIButton, UIForm, UIFormInput, UIFormTextarea } from '@dundle/ui/components';
import ServiceAttachment from './ServiceAttachment.vue';
import TranslationMixin from '~/mixins/TranslationMixin';
import ServiceNotification from '~/components/service/ServiceNotification';
export default {
    components: {
        UIButton,
        UIForm,
        UIFormInput,
        UIFormTextarea,
        ServiceNotification,
        ServiceAttachment,
    },
    mixins: [TranslationMixin],
    props: ['notifications'],
    data() {
        return {
            form: {
                name: '',
                email: '',
                message: '',
                files: [],
            },
            show: true,
            errors: [],
        };
    },
    computed: {
        placeholderName() {
            return this.translate('contact.name');
        },
        placeholderEmail() {
            return this.translate('contact.email');
        },
        placeholderMessage() {
            return this.translate('contact.message');
        },
    },
    methods: {
        async onSubmit() {
            if (!this.$validation.validateForm(this.$refs.contactForm)) return false;

            const multiPartForm = new FormData();

            multiPartForm.append('name', this.form.name);
            multiPartForm.append('email', this.form.email);
            multiPartForm.append('message', this.form.message);

            if (this.form.files.length) {
                multiPartForm.append('tag', '[ATTACHED_FILES]');
                this.$gtm.push({ event: 'event_service_form_uploaded_with_attached_files' });
                for (const file of this.form.files) {
                    multiPartForm.append('files', file);
                }
            }

            let res;
            try {
                res = await this.$api.actions.contact(multiPartForm);
            } catch (error) {
                console.error(error);
                if (error.response?.status === 400) {
                    this.errors.push(this.translate('errors.fileType'));
                }
            }

            if (res?.posted === true) {
                this.emptyForm();
            }
        },
        emptyForm() {
            this.show = false;
            this.form.name = '';
            this.form.email = '';
            this.form.message = '';
            this.form.files = [];
        },
    },
};
</script>

<style lang="scss" scoped>
#contact-form {
    textarea {
        min-height: 150px;
    }

    input,
    textarea {
        font-size: 16px;
    }

    textarea::placeholder {
        color: $color-grey-4;
    }

    .succes-box {
        position: relative;
        padding: 0.75rem 1.25rem;
        margin-bottom: 200px;
        border: 1px solid transparent;
        border-radius: 0.25rem;
        color: darken($color-validation, 20%);
        background: rgba($color-validation, 0.15);
        border-color: rgba($color-validation, 0.3);
    }
}
</style>

<i18n src="@dundle/locale/data/buttons.json"></i18n>
<i18n src="@dundle/locale/data/keywords.json"></i18n>
<i18n src="@dundle/locale/data/validation.json"></i18n>
<i18n src="@dundle/locale/data/contact.json"></i18n>
<i18n></i18n>
